import { Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as SettingsActions from 'src/app/store/settings/actions';
import * as Reducers from 'src/app/store/reducers';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-template-sidebar',
	templateUrl: './template-sidebar.component.html',
	styleUrls: ['./template-sidebar.component.scss'],
})
export class TemplateSidebarComponent implements OnDestroy{
	isTopbarFixed = true;

	isSidebarOpen: boolean;
	isMenuCollapsed: boolean;
	isMenuShadow: boolean;
	isMenuUnfixed: boolean;
	menuLayoutType: string;
	menuColor: string;
	flyoutMenuColor: string;
	systemLayoutColor: string;
	isFooterDark: boolean;
	isContentMaxWidth: boolean;
	isAppMaxWidth: boolean;
	isGrayBackground: boolean;
	isGrayTopbar: boolean;
	isCardShadow: boolean;
	isSquaredBorders: boolean;
	isBorderless: boolean;
	locale: string;
	leftMenuWidth: number;
	logo: string;
	authPagesColor: string;
	theme: string;

	defaultColor = '#4b7cf3';
	window: any = window as any;
	isSidebarAvailable: boolean;

	private subscription = new Subscription();

	constructor(
		private store: Store<any>,
	) {
		this.subscription.add(this.store.pipe(select(Reducers.getSettings)).subscribe(state => {
			this.isMenuCollapsed = state.isMenuCollapsed;
			this.isMenuShadow = state.isMenuShadow;
			this.isMenuUnfixed = state.isMenuUnfixed;
			this.menuLayoutType = state.menuLayoutType;
			this.menuColor = state.menuColor;
			this.flyoutMenuColor = state.flyoutMenuColor;
			this.systemLayoutColor = state.systemLayoutColor;
			this.isFooterDark = state.isFooterDark;
			this.isContentMaxWidth = state.isContentMaxWidth;
			this.isAppMaxWidth = state.isAppMaxWidth;
			this.isGrayBackground = state.isGrayBackground;
			this.isGrayTopbar = state.isGrayTopbar;
			this.isCardShadow = state.isCardShadow;
			this.isSquaredBorders = state.isSquaredBorders;
			this.isBorderless = state.isBorderless;
			this.locale = state.locale;
			this.leftMenuWidth = state.leftMenuWidth;
			this.logo = state.logo;
			this.authPagesColor = state.authPagesColor;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	settingChange(value: boolean, setting: string): void {
		this.store.dispatch(
			new SettingsActions.SetStateAction({
				[setting]: value,
			}),
		);
	}

	setWidth(value: number): void {
		this.store.dispatch(
			new SettingsActions.SetStateAction({
				leftMenuWidth: value,
			}),
		);
	}
}
